import { Spin } from '@bedrock/components'
import React from 'react'

interface Props {
  defaultHeight?: number
  style?: React.CSSProperties
}

const CenterLoading: React.FC<Props> = ({
  defaultHeight = 300,
  style
}) => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: defaultHeight, ...style }}>
      <Spin />
    </div>
  )
}

export default CenterLoading
